import { animationDirList } from "../configParams";

export const dotMovement = (test) => {
  const roundDot = document.getElementsByClassName("round_dot")[0];
  if (test.length > 0) {
    roundDot.style.animationName = animationDirList[`${test[0]}`];
  } else {
    roundDot.style.display = "none";
  }
};
